import $ from './AjaxRequest';

export default {
    post(url, data) {
        data = data || {};
        const newData = {};
        Object.keys(data).forEach(key => {
            if (typeof data[key] !== 'object') {
                newData[key] = data[key];
            }
        });
        return new Promise((resolve, reject) => {
            $.sendRequest({
                method: 'POST',
                url,
                data: newData,
                dataType: 'json',
                doneResult: resolve,
                errorResult: reject,
            });
        });
    }
};


// WEBPACK FOOTER //
// ./src/common/Fetch.js